// IMP-362: a shared convention for the message posted on the user's behalf when
// they submit a confirmation card in the chat. Every message is a plain-language
// header followed by a structured list, so the conversation history is
// consistent and easy to scan.
//
// User messages render as plain text (newlines preserved), not markdown, so
// these use literal "- Name → Action" bullets and two-space-indented
// "Key: Value" lines rather than markdown syntax.

// Joins a plain-language header with structured blocks (separated by `separator`
// — a single newline for stacked lines, a blank line between grouped sections).
// Returns just the header when there are no blocks.
export function confirmationMessage(
  header: string,
  blocks: string[],
  separator = "\n",
): string {
  const body = blocks.filter((b) => b.trim() !== "").join(separator)
  return body ? `${header}\n\n${body}` : header
}

// A flat disposition line: "- Name → Action".
export function dispositionLine(name: string, action: string): string {
  return `- ${name} → ${action}`
}

// A grouped field/value block: a subject header, then two-space-indented
// "Key: Value" lines (one per field).
export function fieldGroup(
  subject: string | null | undefined,
  pairs: { label: string; value: string }[],
): string {
  const lines = pairs.map((p) => `  ${p.label}: ${p.value}`)
  const subjectLine = subject?.trim()
  return (subjectLine ? [subjectLine, ...lines] : lines).join("\n")
}
